export default {
  'reports.title': 'Reportes',
  'reports.button.open': 'Abrir',
  'reports.manageReports.title': 'Gestionar Reportes',
  'reports.manageGroups.title': 'Configurar Grupo de Reportes',
  'reports.tab.groups': 'Grupos',
  'reports.tab.favorites': 'Favoritos',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Configuración Servidor Power BI',
  'reports.manageGroups.components.powerBIReportGroupId': 'Id Grupo de PowerBI',
  'reports.manageGroups.components.powerBIReportId': 'Id Reporte PowerBI',
  'reports.manageGroups.components.menuTitle': 'Titulo del Menú',
  'reports.manageGroups.components.menuTooltip': 'Texto de ayuda del Menú',
  'reports.manageGroups.components.textHelp': 'Texto de ayuda del Menú',
  'reports.manageGroups.components.asLink': 'Mostrar como Vínculo',
  'reports.manageGroups.components.powerBIConnector': 'Conector de Power BI',

  'reports.manageReports.components.report-group': 'Grupo de Reportes',
  'reports.manageReports.components.tagLink': 'Etiquetas de Rlasificación del Reporte',
  'reports.manageReports.components.multiplePages': '¿Múltiples páginas?',
  'reports.manageReports.components.defaultReport': 'Sección del Report Predeterminada',
  'reports.manageReports.components.enableDataFilter':
    '¿Habilitar Filtro de Datos de Reporte por Usuario?',
  'reports.manageReports.components.reportFilter':
    '¿Habilitar Filtro de datos de Reporte por Usuario?',

  'reports.manageReports.components.reportId': 'Id Reporte PowerBI',
  'reports.manageReports.components.datasetId': 'Id Dataset PowerBI',
  'reports.manageReports.components.defaultReportSection': 'Sección del Reporte Predeterminada',
  'reports.manageReports.components.isMultipage': '¿Múltiples Páginas?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    '¿Habilitar Filtro de Datos de Reporte por Usuario?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    '¿Filtro de Datos de Reporte por Puesto?',
  'reports.platform': 'Plataforma',

  'reports.manageReports.components.reportDataFilterUserTableName':
    'Nombre de Tabla para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterUserFieldName':
    'Nombre de Campo para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Nombre Interno de Campo para Filtro por Usuario',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Nombre de Tabla para Filtro por Puesto',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Nombre de Campo para Filtro por Puesto',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Nombre Interno de Campo para Filtro por Puesto',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',

  'reports.type.administration': 'Administración',
  'reports.type.process': 'Proceso',
  'reports.type.request': 'Solicitud',
  'reports.type.generic': 'Genérico',
  'reports.type.powerbiconnector': 'Conector Power BI',

  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Movil',
  'reports.platform.webmobile': 'WebMovil',

  'reports.export.title': 'Exportar reporte',
  'reports.export.pdf': 'Exportar como PDF',
  'reports.export.pptx': 'Exportar como PowerPoint',
  'reports.export.requestSent':
    'Solicitud de exportación enviada. Recibirás una notificación cuando esté lista.',
  'reports.export.generating': 'Generando...',
  'reports.export.inProgress': 'Generando',
  'reports.export.ready': 'Archivo listo para descargar',
  'reports.export.error': 'Error al generar el archivo',
  'reports.export.failed': 'Error',
  'reports.fullscreen': 'Pantalla completa',
  'reports.exitFullscreen': 'Salir de pantalla completa',
};
